module.exports = __webpack_public_path__ + "img/logo.50f14f8c.png";